export default __webpack_public_path__ + "static/eberle-7c617b7542a00689ec4f240f84c1913f.jpg";